import Loadable from 'react-loadable';
import { Loading } from '@vezeeta/web-components';

export const BidsDashBoard = Loadable({
  loader: () => import('views/bidsDashBoard/BidsDashBoardContainer'),
  loading: Loading,
});

export const PaymentDetails = Loadable({
  loader: () => import('views/paymentDetails/PaymentDetailsContainer'),
  loading: Loading,
});
